import { API_BASE_URL } from '../config/api';

export interface VoiceSettingsSnapshot {
  voice_mode?: 'full' | 'basic' | 'silent';
  voice_provider?: 'builtin' | 'elevenlabs' | 'custom';
  selected_voice?: string;
  elevenlabs_api_key?: string;
  has_elevenlabs_api_key?: boolean;
  elevenlabs_voice_id?: string;
  custom_voice_id?: string;
  default_language?: string;
}

export const readCachedVoiceSettings = (): VoiceSettingsSnapshot => {
  try {
    const raw = localStorage.getItem('voiceSettings');
    if (raw) return JSON.parse(raw) as VoiceSettingsSnapshot;
  } catch {
    /* ignore malformed cache */
  }
  return {};
};

/** Load voice settings from cache, falling back to the server when needed. */
export const getVoiceSettings = async (forceRefresh = false): Promise<VoiceSettingsSnapshot> => {
  if (!forceRefresh) {
    const cached = readCachedVoiceSettings();
    if (cached.voice_provider) return cached;
  }

  try {
    const token = localStorage.getItem('token') || localStorage.getItem('auth_token');
    if (!token) return readCachedVoiceSettings();

    const response = await fetch(`${API_BASE_URL}/settings/voice`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (response.ok) {
      const data = await response.json();
      const settings = (data.data?.voiceSettings || {}) as VoiceSettingsSnapshot;
      localStorage.setItem('voiceSettings', JSON.stringify(settings));
      return settings;
    }
  } catch (err) {
    console.warn('Failed to fetch voice settings:', err);
  }

  return readCachedVoiceSettings();
};

export const preloadVoiceSettings = async (): Promise<void> => {
  await getVoiceSettings();
};
